module.exports = __webpack_public_path__ + "33b68abfcb89ac4f85c7ace08ca3ba59.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/large/leonardo-da-vinci.jpg
 ** module id = 402
 ** module chunks = 0
 **/